export default "__VITE_ASSET__DeIPp6yJ__"